/* !
 * jQuery index v1.0.0
 * Copyright 2019, Connecty Inc.
 */
(function ($, RIKEN) {
	const a = 'is-active';
	const v = 'is-visible';
	const f = 'is-fixed';
	const h = 'is-hidden';
	const arrowPrev = '<button type="button" class="slick-prev"><svg class="icon" data-view="pc"><use xlink:href="/common/svg/sprite.svg#arrow_left" /></svg><img src="/common/images/arrow_left_waku.svg" class="icon" data-view="tablet sp" /></button>';
	const arrowNext = '<button type="button" class="slick-next"><svg class="icon" data-view="pc"><use xlink:href="/common/svg/sprite.svg#arrow_right" /></svg><img src="/common/images/arrow_right_waku.svg" class="icon" data-view="tablet sp" /></button>';
	const $path = location.pathname;

	// ==============================================================
	// JSON取得 =====================================================
	// 新商品・リニューアル商品
	const getJSONproductsData = (_key) => {
		return $.getJSON(`/ajax/products/${_key}.json`);
	}
	// 販売終了商品
	const getJSONoldCategoryData = (_category) => {
		return $.getJSON(`/ajax/products/old/${_category}.json`);
	}
	// アレルゲン情報
	const getJSONseriesAllergyData = (_series) => {
		return $.getJSON(`/ajax/products/allergy/${_series}.json`);
	}
	// 全レシピ取得用
	const getJSONallrecipeData = () => {
		return $.getJSON('/ajax/recipe_all/list.json');
	}
	// シリーズごとの商品取得用
	const getJSONallseriesRecipeData = (_key) => {
		return $.getJSON(`/ajax/products/recipe/series/${_key}.json`);
	}
	// レシピ情報取得
	const getJSONrecipeData = (_key) => {
		return $.getJSON(`/ajax/recipe/${_key}.json`);
	}
	// シリーズ一覧取得
	const getJSONseries = () => {
		return $.getJSON(`/ajax/recipe_search/products/series.json`);
	}
	// ==============================================================
	// JSTに変換
	const convertJST = (time) => {
		time = new Date(time);
		return new Date(time.toLocaleString().slice(0, -3));
	}
	// 動的に書き出す®をsubで囲う
	const addSub = (_txt) => {
		if (_txt.indexOf('®') !== -1 || _txt.indexOf('🄬') !== -1 || _txt.indexOf('&reg;') !== -1) {
			let newTxt = _txt.replace(/®|🄬|&reg;/g, '<sub>&reg;</sub>');
			return newTxt;
		} else {
			return _txt;
		}
	}


	// ==============================================================
	// <TOP> メインスライダー
	const topMainSlider = () => {
		const thisSlider = $('.js-main-slider');
		const thisSliderDots = thisSlider.next('.mod-slider-dots');
		if (thisSlider.length) {
			thisSlider.slick({
				infinite: true,
				speed: 1000,
				autoplaySpeed: 4000,
				autoplay: true,
				slidesToShow: 1,
				arrows: true,
				dots: true,
				prevArrow: arrowPrev,
				nextArrow: arrowNext,
				appendDots: thisSliderDots,
			});

			// 再生ボタン
			thisSliderDots.find('button.__play').on('click', () => {
				thisSliderDots.toggleClass(a);
				thisSlider.slick('slickPlay');
			});
			// 停止ボタン
			thisSliderDots.find('button.__pause').on('click', () => {
				thisSliderDots.toggleClass(a);
				thisSlider.slick('slickPause');
			});
		}
	};

	// <TOP>新商品・リニューアル商品スライダー
	const newProductsSlider = () => {
		const thisSlider = $('.js-newProducts-slider');
		const thisSliderDots = thisSlider.next('.mod-slider-dots');
		if (thisSlider.length) {
			thisSlider.slick({
				infinite: true,
				speed: 1000,
				autoplaySpeed: 4000,
				autoplay: true,
				slidesToShow: 4,
				arrows: true,
				dots: true,
				prevArrow: arrowPrev,
				nextArrow: arrowNext,
				appendDots: thisSliderDots,
				responsive: [
					{
						breakpoint: 1025,
						settings: {
							slidesToShow: 2,
							speed: 500,
						}
					}
				]
			});

			// 再生ボタン
			thisSliderDots.find('button.__play').on('click', () => {
				thisSliderDots.toggleClass(a);
				thisSlider.slick('slickPlay');
			});
			// 停止ボタン
			thisSliderDots.find('button.__pause').on('click', () => {
				thisSliderDots.toggleClass(a);
				thisSlider.slick('slickPause');
			});
		}
	};
	// <TOP>キャンペーンスライダー
	const campaignSlider = () => {
		const thisSlider = $('.js-campaign-slider');
		const thisSliderDots = thisSlider.next('.mod-slider-dots');
		if (thisSlider.length) {
			thisSlider.slick({
				infinite: true,
				speed: 1000,
				autoplaySpeed: 4000,
				autoplay: true,
				slidesToShow: 3,
				arrows: true,
				dots: true,
				prevArrow: arrowPrev,
				nextArrow: arrowNext,
				appendDots: thisSliderDots,
				responsive: [
					{
						breakpoint: 1025,
						settings: {
							slidesToShow: 2,
							arrows: false,
							speed: 500,
						}
					}, {
						breakpoint: 768,
						settings: {
							slidesToShow: 1,
							arrows: false
						}
					}
				]
			});

			// 再生ボタン
			thisSliderDots.find('button.__play').on('click', () => {
				thisSliderDots.toggleClass(a);
				thisSlider.slick('slickPlay');
			});
			// 停止ボタン
			thisSliderDots.find('button.__pause').on('click', () => {
				thisSliderDots.toggleClass(a);
				thisSlider.slick('slickPause');
			});
		}
	};
	// <TOP>ブランドスライダー
	const brandSlider = () => {
		const thisSlider = $('.js-brand-slider');
		const thisSliderDots = thisSlider.next('.mod-slider-dots');
		if (thisSlider.length) {
			thisSlider.slick({
				infinite: true,
				speed: 1000,
				autoplaySpeed: 4000,
				autoplay: true,
				slidesToShow: 3,
				arrows: true,
				dots: true,
				prevArrow: arrowPrev,
				nextArrow: arrowNext,
				appendDots: thisSliderDots,
				responsive: [
					{
						breakpoint: 1025,
						settings: {
							slidesToShow: 2,
							arrows: false,
							speed: 500,
						}
					}, {
						breakpoint: 768,
						settings: {
							slidesToShow: 1,
							arrows: false
						}
					}
				]
			});

			// 再生ボタン
			thisSliderDots.find('button.__play').on('click', () => {
				thisSliderDots.toggleClass(a);
				thisSlider.slick('slickPlay');
			});
			// 停止ボタン
			thisSliderDots.find('button.__pause').on('click', () => {
				thisSliderDots.toggleClass(a);
				thisSlider.slick('slickPause');
			});
		}
	};
	// <TOP>「おいしさの提案」スライド
	const deliciousnessSlider = () => {
		$('.js-deliciousness-slider').slick({
			infinite: true,
			speed: 800,
			autoplay: false,
			pauseOnHover: false,
			// autoplaySpeed: 5000,
			slidesToShow: 1,
			fade: true,
			arrows: true,
			dots: true,
			prevArrow: arrowPrev,
			nextArrow: arrowNext,
			adaptiveHeight: true,
			responsive: [
				{
					breakpoint: 1025,
					settings: {
						speed: 500,
					}
				}
			]
		});
	};

	// <TOP>「新商品・リニューアル商品」
	const newProducts = () => {
		if ($('.js-newProducts-link').length) {
			$('.js-newProducts-link').each((idx, ele) => {
				if ($(ele).hasClass('rt_cf_p_detail_page_flag_is')) {
					let thisKey = $(ele).find('.rt_pp_products_key').text();
					getJSONproductsData(thisKey).then((data) => {
						if (data.rt_bn_products_list.length) {
							let _categoryData = data.rt_bn_products_list[0].cf_p_category;
							let _category = _categoryData.cf_pc_code;
							let _series = _categoryData.cf_pc_series_code;
							let thisHref = '/products/' + _category + '/' + _series + '/' + thisKey + '.html';
							$(ele).find('.products-item').attr('href', thisHref);
						} else {
							$(ele).parents('.js-newProducts-item').remove();
						}
					})
				}
				if (idx === $('.js-newProducts-link').length - 1) {
					newProductsSlider();
				}
			});
		}

		if ($('.js-newProducts-item').length) {
			$('.js-newProducts-item').each((idx, ele) => {
				if ($(ele).find('.rt_cf_p_status_common').text() === '0') {
					$(ele).remove();
				}
			});
		}
	}


	// おすすめコンテンツ
	const recommendContentsSlider = () => {
		const thisSlider = $('.js-recommend-slider');
		const thisSliderDots = thisSlider.next('.mod-slider-dots');
		if (thisSlider.length) {
			thisSlider.slick({
				infinite: true,
				speed: 1000,
				autoplaySpeed: 4000,
				autoplay: true,
				slidesToShow: 4,
				arrows: true,
				dots: true,
				prevArrow: arrowPrev,
				nextArrow: arrowNext,
				appendDots: thisSliderDots,
				responsive: [
					{
						breakpoint: 1024,
						settings: {
							slidesToShow: 2,
							arrows: false,
							speed: 500,
						}
					}, {
						breakpoint: 768,
						settings: {
							slidesToShow: 1,
							arrows: false,
							speed: 500,
						}
					}
				]
			});
			// 再生ボタン
			thisSliderDots.find('button.__play').on('click', () => {
				thisSliderDots.toggleClass(a);
				thisSlider.slick('slickPlay');
			});
			// 停止ボタン
			thisSliderDots.find('button.__pause').on('click', () => {
				thisSliderDots.toggleClass(a);
				thisSlider.slick('slickPause');
			});
		}
	};

	// カテゴリページ
	const creteSeriesRecipe = () => {
		if ($('.js-recipeList').length) {
			// 共通
			let productsAll = [];
			getJSONseries().then((data) => {
				let seriesData = data.rt_bn_products_series_list;
				for (let i = 0; i < seriesData.length; i++) {
					getJSONallseriesRecipeData(seriesData[i].cf_pc_series_code).then((data2) => {
						let productsData = data2.rt_bn_products_list;
						for (let j = 0; j < productsData.length; j++) {
							productsAll.push(productsData[j]._key);
						}
					});
				}
			});

			let today = new Date(new Date().setHours(0, 0, 0, 0));
			$('.js-recipeList').each((idx, ele) => {
				let thisKey = $(ele).find('.rt_cf_pc_series_code').text();
				let seriesArr = [];
				getJSONallseriesRecipeData(thisKey).then((data) => {
					let seriesData = data.rt_bn_products_list;
					for (let i = 0; i < seriesData.length; i++) {
						seriesArr.push(seriesData[i]._key);
					}
				}).done((data) => {
					let recipeArr = [];
					getJSONallrecipeData().then((data2) => {
						let recipeData = data2.rt_bn_recipe_all_list;
						for (let j = 0; j < recipeData.length; j++) {
							let _recipeKey = recipeData[j]._key;
							let _products = recipeData[j].cf_r_products_main;
							let _subKeyArr = recipeData[j].cf_r_products_sub;
							if (_products !== null) {
								let _productsKey = recipeData[j].cf_r_products_main._key;
								if (seriesArr.indexOf(_productsKey) !== -1 && productsAll.indexOf(_productsKey) !== -1) {
									recipeArr.push(recipeData[j])
								}
								if (_subKeyArr !== null && _subKeyArr.length) {
									for (let k = 0; k < _subKeyArr.length; k++) {
										if (productsAll.indexOf(_subKeyArr[k]._key) === -1) {
											recipeArr.some(function (x, y) {
												if (x._key == _recipeKey) recipeArr.splice(y, 1);
											});
										}
									}
								}
							}
						}
						recipeArr.sort(
							function (x, y) {
								let xDate = x['cf_r_register_day'];
								let yDate = y['cf_r_register_day'];
								if (xDate > yDate) return (-1);
								if (xDate < yDate) return (1);
								return 0;
							}
						);
					}).done(() => {
						let count = 0;
						if (!recipeArr.length) {
							$(ele).parents('.js-recipeList-wrap').remove();
						}
						if (recipeArr.length > 4) {
							$(ele).find('.js-recipeList-link').removeClass('di_none');
						}
						for (let k = 0; k < 4; k++) {
							let _name = recipeArr[k].cf_r_name;
							let _id = recipeArr[k]._key;
							let _img = recipeArr[k].cf_r_img;
							let _alt = recipeArr[k].cf_r_img_alt;
							let _title = recipeArr[k].cf_r_img_title;
							let _time = recipeArr[k].cf_r_cooking_time;
							let _timeunit = recipeArr[k].cf_r_cooking_time_unit;
							let _timiSupplement = recipeArr[k].cf_r_cooking_time_supplement;
							let _date = recipeArr[k].cf_r_register_day;
							let _productsName = recipeArr[k].cf_r_products_main.cf_p_name;
							let _productsKey = recipeArr[k].cf_r_products_main._key;
							let _tagList = recipeArr[k].cf_r_tags;
							let _detailPage = recipeArr[k].cf_r_detail_url;
							let _genre = '';
							let newHtml = '';
							let productsLink = '';
							let linkClass = '';
							let linkTarget = '_self';
							let recipeUrl = '/recipe/detail/' + _id + '.html';

							// 詳細ページの指定がある場合
							if (_detailPage !== '') {
								recipeUrl = _detailPage;
								if (recipeUrl.indexOf('//') !== -1) {
									linkTarget = '_blank';
								}
							}
							// 登録日から2週間後の日付を取得
							let created = convertJST(_date);
							created.setHours(0, 0, 0, 0);
							created.setDate(created.getDate() + 14);
							if (created >= today) {
								newHtml = '<span class="__new">NEW</span>';
							}

							// 商品の詳細ページ取得
							getJSONproductsData(_productsKey).then((data3) => {
								let productsData = data3.rt_bn_products_list;
								count += 1;

								if (productsData.length) {
									let _flg = productsData[0].cf_p_detail_page_flag;
									let _category = productsData[0].cf_p_category.cf_pc_code;
									let _series = productsData[0].cf_p_category.cf_pc_series_code;

									if (_flg === 0) {
										productsLink = '/products/' + _category + '/' + _series + '/' + _productsKey + '.html';
									} else {
										linkClass = 'is-disable';
									}
								}
							}).then(() => {
								let recipeHtml = `<li class="pure-u-1-4 pure-u-lg-1 space-u-40-child" style="order:${k};">
									<div class="recipe-item">
										<div class="recipe-item-img">
											<a href="${recipeUrl}" target="${linkTarget}" class="__img">
												<figure class="">
													<img src="/recipe_file/file/${_img}" alt="${_alt}" title="${_title}" class="width-u-100">
												</figure>
											</a>
											<div class="recipe-item-label">
												${newHtml}
												<span class="__time">
													<svg class="icon"><use xlink:href="/common/svg/sprite.svg#time"></use></svg>
													<span>${_time}${_timeunit}</span>
												</span>
											</div>
										</div>
										<a href="${recipeUrl}" target="${linkTarget}" class="__tit"><span>${addSub(_name)}</span></a>
										<div class="recipe-item-products">
											<div class="recipe-item-products-inner">
												<div class="__txtWrap">
													<p class="__head">使用している商品：</p>
													<a href="${productsLink}" class="__txt ${linkClass}"><span>${addSub(_productsName)}</span></a>
												</div>
											</div>
										</div>
									</div>
								</li>`;
								$(ele).find('.js-recipeSlider').append(recipeHtml);
							}).then(() => {
								if (count === 4 || count === recipeArr.length) {
									categoryRecipeSlider($(ele));
								}
							});
						}
					});
				});
			});
		}
	}
	//  <カテゴリーページ>
	const categoryTab = () => {
		if ($('.js-categoryTab').length) {
			$('.js-categoryTab').each((idx, ele) => {
				if ($path === $(ele).attr('href') || $path === $(ele).attr('href') + 'index.html') {
					$('.js-categoryTab').removeClass(a);
					$(ele).addClass(a);
				}
			});
		}
		// ページ下部「カテゴリ一覧」現在カテゴリを非活性化
		if ($('.js-category-list').length) {
			$('.js-category-list').each((idx, ele) => {
				let thisCategory = $(ele).find('a').attr('href');
				if (thisCategory === $path || thisCategory + 'index.html' === $path) {
					$(ele).find('a').addClass('is-disable');
				}
			});
		}

	};

	// <商品検索>
	const productsSearch = () => {
		const $input = $('.js-search-input');
		const $btn = $('.js-search-btn');
		const $form = $('.js-search-form');
		let param = '';

		$form.on('submit', (e) => {
			e.preventDefault();
			const keywords = $input.val().replaceAll(' ', '　').split('　');

			const searchParams = new URLSearchParams(location.search);
			const newSearchParams = new URLSearchParams();
			keywords.forEach((item, idx) => {
				newSearchParams.set(`p_keyword_${idx + 1}`, item);
			});
			newSearchParams.set('p_category', searchParams.get('p_category') || '');

			location.href = `/products/search.html?${newSearchParams.toString()}`;
		});
		
		// $input.on('change', (e) => {
		// 	let thisVal = $input.val();
		// 	let txtArr;
		// 	if (thisVal.indexOf(' ') !== -1 || thisVal.indexOf('　') !== -1) {
		// 		txtArr = thisVal.split(/[\s\u{3000}]/ug);
		// 	} else {
		// 		txtArr = [thisVal];
		// 	}
		// 	for (let i = 0; i < txtArr.length; i++) {
		// 		if (i === 0) {
		// 			param += 'p_keyword_' + Number(i + 1) + '=' + txtArr[i];
		// 		} else {
		// 			param += '&p_keyword_' + Number(i + 1) + '=' + txtArr[i];
		// 		}
		// 	}
		// 	param += '&p_category=';
		// 	$form.attr('action', '/products/search.html?' + param);
		// });

		// 検索結果
		if ($path === '/products/search.html') {
			let $search = location.search;
			// inputに検索ワードを反映
			let paramArr = $search.split('&');
			let keywordsArr = [];
			for (let i = 0; i < paramArr.length; i++) {
				if (paramArr[i].indexOf('p_keyword_') !== -1) {
					keywordsArr.push(paramArr[i].split('=')[1].replace('+', ' '));
				} else if (paramArr[i].indexOf('p_category') !== -1) {
					if (paramArr[i].split('=')[1] === '') {
						$('.js-category-radio[value=""]').prop('checked', true);
					}
				}
			}
			keywordsArr = keywordsArr.filter(Boolean);
			$input.val(decodeURI(keywordsArr.join('　')));
			$('.js-search-txt').text(decodeURI(keywordsArr.join('　')));
			if ($input.val() !== '') {
				$('.js-search-txtWrap').removeClass('di_none');
			}

			// ラジオボタンクリックで遷移
			$('.js-category-radio').on('click', (e) => {
				const searchParams = new URLSearchParams(location.search);
				let thisVal = $(e.currentTarget).val();

				searchParams.set('p_category', thisVal);
				location.href = `/products/search.html?${searchParams.toString()}`;
			});
		};
	};

	// <商品検索結果>
	const brandStorySlider = () => {
		// tabletとSPのみスライド
		const sliderSetting = () => {
			let width = $(window).width();
			let thisSlider = $('.js-brandstorySlider');
			thisSlider.each(function() {
				const ele = $(this);
				const thisSliderDots = ele.next('.mod-slider-dots');
				if (width <= 1024) {
					if (!ele.hasClass('slick-initialized')) {
						ele.slick({
							infinite: true,
							speed: 1000,
							autoplaySpeed: 4000,
							autoplay: true,
							slidesToShow: 2,
							arrows: true,
							dots: true,
							prevArrow: arrowPrev,
							nextArrow: arrowNext,
							appendDots: thisSliderDots,
							responsive: [
								{
									breakpoint: 768,
									settings: {
										slidesToShow: 1,
									}
								}
							]
						});

						// イベント登録（初期化時のみ）
						thisSliderDots.find('button.__play').off('click').on('click', () => {
							thisSliderDots.toggleClass(a);
							ele.slick('slickPlay');
						});
						
						thisSliderDots.find('button.__pause').off('click').on('click', () => {
							thisSliderDots.toggleClass(a);
							ele.slick('slickPause');
						});
					}
				} else {
					if(ele.hasClass('slick-initialized')) {
						ele.slick('unslick');
					}
				}
			});
		};
		sliderSetting();

		$(window).resize(() => {
			sliderSetting();
		});
	};
	// <カテゴリ>レシピ スライダー
	const categoryRecipeSlider = (_item) => {
		const thisSlider = _item.find('.js-recipeSlider');
		if (thisSlider.length) {
			const thisSliderDots = thisSlider.next('.mod-slider-dots');
			// スライド初期化
			if (thisSlider.hasClass('slick-initialized')) {
				thisSlider.slick('unslick');
			}
			// tabletとSPのみスライド
			const sliderSetting = () => {
				let width = $(window).width();
				if (width <= 1024) {
					thisSlider.not('.slick-initialized').slick({
						infinite: true,
						speed: 1000,
						autoplaySpeed: 4000,
						autoplay: true,
						slidesToShow: 2,
						arrows: false,
						dots: true,
						appendDots: thisSliderDots,
						responsive: [
							{
								breakpoint: 768,
								settings: {
									slidesToShow: 1,
								}
							}
						]
					});

					// 再生ボタン
					thisSliderDots.find('button.__play').on('click', () => {
						thisSliderDots.toggleClass(a);
						thisSlider.slick('slickPlay');
					});
					// 停止ボタン
					thisSliderDots.find('button.__pause').on('click', () => {
						thisSliderDots.toggleClass(a);
						thisSlider.slick('slickPause');
					});
				} else {
					if (thisSlider.hasClass('slick-initialized')) {
						thisSlider.slick('unslick');
					}
				}
			};

			sliderSetting();

			$(window).resize(() => {
				sliderSetting();
			});
		}
	};
	// <商品詳細>この商品を使ったレシピ スライダー
	const recipeDetailSlider = () => {
		const thisSlider = $('.js-recipeSlider');
		if (thisSlider.length) {
			const thisSliderDots = thisSlider.next('.mod-slider-dots');
			// tabletとSPのみスライド
			if (thisSlider.hasClass('slick-initialized')) {
				thisSlider.slick('unslick');
			}
			const sliderSetting = () => {
				let width = $(window).width();
				if (width <= 1024) {
					thisSlider.not('.slick-initialized').slick({
						infinite: true,
						speed: 1000,
						autoplaySpeed: 4000,
						autoplay: true,
						slidesToShow: 2,
						arrows: false,
						dots: true,
						appendDots: thisSliderDots,
						responsive: [
							{
								breakpoint: 768,
								settings: {
									slidesToShow: 1,
								}
							}
						]
					});
					// 再生ボタン
					thisSliderDots.find('button.__play').on('click', () => {
						thisSliderDots.toggleClass(a);
						thisSlider.slick('slickPlay');
					});
					// 停止ボタン
					thisSliderDots.find('button.__pause').on('click', () => {
						thisSliderDots.toggleClass(a);
						thisSlider.slick('slickPause');
					});
				} else {
					if (thisSlider.hasClass('slick-initialized')) {
						thisSlider.slick('unslick');
					}
				}
			};

			sliderSetting();

			$(window).resize(() => {
				sliderSetting();
			});
		}
	};
	// <商品詳細>(SP)テーブルスワイプ
	const tableSwipe = () => {
		if ($('.js-swipe').length) {
			$('.js-swipe').on('touchmove', (e) => {
				$(e.currentTarget).find('.__swipe').addClass(h);
			});
		}
	};
	// <商品詳細>アレルゲン情報
	const detailAllergy = () => {
		if ($('.js-allergy-td').length) {
			$('.js-allergy-td').each((idx, ele) => {
				if ($(ele).find('span').length === 0) {
					$(ele).text('－');
				} else {
					$(ele).find('span').each((idx2, ele2) => {
						if (idx2 !== 0) {
							$(ele2).before('、');
						}
					});
				}
			});
		}
	};
	// <商品詳細>　項目非表示
	const detailItemDisplay = () => {
		if ($('.js-products-info').length) {
			// 基本情報
			$('.js-products-info').find('tr').each((idx, ele) => {
				if ($(ele).children('td').length === 0 || $(ele).children('td').text().trim() === '') {
					$(ele).remove();
				}
			});
			// お知らせ
			if ($('.js-detail-notice').text() === '') {
				$('.js-detail-noticeWrap').remove();
			}
			// 原材料名
			if ($('.js-detail-materials').text() === '') {
				$('.js-detail-materialsWrap').remove();
			}
			// 栄養成分
			if ($('.js-detail-nutritional').text() === '' && $('.js-detail-nutritional-txt').text() === '') {
				$('.js-detail-nutritionalWrap').remove();
			}
			if ($('.js-detail-nutritional').length) {
				$('.js-detail-nutritional').each((idx, ele) => {
					$(ele).find('.__tr').each((idx2, ele2) => {
						if ($(ele2).find('.__td').text().trim() === '') {
							$(ele2).remove();
						}
					});
					if (!$(ele).children('li').length) {
						$(ele).remove();
					}
				});
			}
			// ご注意
			if ($('.js-detail-attention').text() === '') {
				$('.js-detail-attentionWrap').remove();
			}
			// ラインナップ
			if (!$('.js-detail-lineup').length) {
				$('.js-detail-lineupWrap').remove();
			} else {
				newProductsSlider();
			}
			// この商品を使ったレシピ
			if (!$('.js-detail-lineup').length) {
				$('.js-detail-lineupWrap').remove();
			}
			// 関連サイト
			if (!$('.js-detail-related').length) {
				$('.js-detail-relatedWrap').remove();
			}
			// ブランドサイト
			if (!$('.js-detail-brandsite').length) {
				$('.js-detail-brandsiteWrap').remove();
			}
			// さらに詳しいアレルゲン情報
			// 空のテーブルを非表示にする
			$('.js-allergy-toggle-tbl').each((idx, ele) => {
				$(ele).find('tr').each((idx2, ele2) => {
					let trText = $(ele2).text().trim();
					if (idx2 !== 0) {
						if (trText !== '') {
							if ($(ele2).find('td.__allergy').length && !$(ele2).find('td.__raw').length) {
								$(ele2).prepend('<td></td>');
							} else if (!$(ele2).find('td.__allergy').length && $(ele2).find('td.__raw').length) {
								$(ele2).append('<td></td>');
							}
							$(ele).parents('.__tblWrap').removeClass('di_none');
						}
					}
				});
			});

			if (!$('.js-allergy-oldBlock').find('.__tblWrap:not(.di_none)').length &&
				!$('.js-allergy-oldBlock').find('.__txt1').length &&
				!$('.js-allergy-oldBlock').find('.__txt2').length) {
				$('.js-allergy-oldBlock').remove();
			}
			if (!$('.js-allergy-newBlock').find('.__tblWrap:not(.di_none)').length &&
				!$('.js-allergy-newBlock').find('.__txt1').length &&
				!$('.js-allergy-newBlock').find('.__txt2').length) {
				$('.js-allergy-newBlock').remove();
			}
			if (!$('.js-allergy-oldBlock').length && !$('.js-allergy-newBlock').length) {
				$('.js-allergy-wrap').remove();
			}
		}
	}
	// <商品詳細>「この商品を使ったレシピ」
	const detailRecipe = () => {
		let productsAll = [];
		if ($('.js-recipe-item').length) {
			let itemAllLen = $('.js-recipe-item').length;
			getJSONseries().then((data) => {
				let seriesData = data.rt_bn_products_series_list;
				for (let i = 0; i < seriesData.length; i++) {
					getJSONallseriesRecipeData(seriesData[i].cf_pc_series_code).then((data2) => {
						let productsData = data2.rt_bn_products_list;
						for (let j = 0; j < productsData.length; j++) {
							productsAll.push(productsData[j]._key);
						}
					}).then(() => {
						if (i === seriesData.length - 1) {
							let count = 0;
							$('.js-recipe-item').each((idx, ele) => {
								let recipeId = $(ele).find('.rt_recipe_key').text();
								getJSONrecipeData(recipeId).then((data) => {
									let recipeData = data.rt_bn_recipe_info;
									count += 1;

									if (recipeData.length) {
										let mainProducts = recipeData[0].cf_r_products_main;
										let subProducts = recipeData[0].cf_r_products_sub;
										let mainProductsKey;

										if (mainProducts !== null) {
											mainProductsKey = mainProducts._key;
										}

										let productsHtml = `<a href="" data-key="${mainProductsKey}" class="__txt js-products-output">
											<span></span>
										</a>`;
										$(ele).find('.js-products-output').append(productsHtml);
										$(ele).addClass('is-visible');

										// サブ商品判定
										if (subProducts !== null && subProducts.length) {
											for (let i = 0; i < subProducts.length; i++) {
												if (productsAll.indexOf(subProducts[i]._key) === -1) {
													$(ele).remove();
													$(ele).removeClass('is-visible');
													if (!$('.js-recipe-item').length) {
														$('.js-detail-recipeWrap').remove();
													}
												}
											}
										}
									}
								}).then(() => {
									if (count === itemAllLen) {
										let test = $('.js-recipe-item.is-visible').length;
										// 合計5件未満の場合　レシピ一覧リンク削除
										if ($('.js-recipe-item.is-visible').length < 5) {
											$('.js-recipeList-link').remove();
										}
										$('.js-recipe-item.is-visible:nth-child(n+5)').remove();
										$('.js-recipe-item.is-visible:nth-child(-n+4)').removeClass('di_none');

										// 商品リンク生成
										let productsList = [];
										$('.js-products-output').each((idx, ele) => {
											let thisProdKey = $(ele).attr('data-key');
											if (productsList.indexOf(thisProdKey) === -1) {
												productsList.push(thisProdKey);
											}
										});

										for (let i = 0; i < productsList.length; i++) {
											getJSONproductsData(productsList[i]).then((data3) => {
												let productsData = data3.rt_bn_products_list;
												let _name = productsData[0].cf_p_name;
												let _category = productsData[0].cf_p_category.cf_pc_code;
												let _series = productsData[0].cf_p_category.cf_pc_series_code;
												let _productsLink = '/products/' + _category + '/' + _series + '/' + productsList[i] + '.html';
												$('.js-products-output[data-key="' + productsList[i] + '"]').attr('href', _productsLink);
												$('.js-products-output[data-key="' + productsList[i] + '"] span').html(addSub(_name));
											});
										}
										recipeDetailSlider();
									}
								});
							});
						}
					});
				}
			});
		} else {
			// 0件の場合ブロックごと削除
			$('.js-detail-recipeWrap').remove();
		}
	};

	// <商品詳細>「さらに詳しいアレルゲン情報を見る」 リロードで開閉状態を保持
	const detailAllergyToggle = () => {
		if ($('.products-detail-allergy-more').length) {
			// セッションストレージに開閉情報をセット
			$('.products-detail-allergy-more .js-toggle').on('click', (e) => {
				if (!$(e.currentTarget).hasClass(a)) {
					sessionStorage.setItem('allergyToggle', true);
				} else {
					sessionStorage.setItem('allergyToggle', false);
				}
			});
			$(document).ready(function () {
				if (performance.navigation.type === 1) {
					let allergyToggle = sessionStorage.getItem('allergyToggle');

					if (allergyToggle === 'true') {
						$('.products-detail-allergy-more .js-toggle').addClass(a);
						$('.products-detail-allergy-more .js-toggle').next('.js-toggleBlock').slideToggle();
					}
				} else {
					sessionStorage.setItem('allergyToggle', false);
				}
			});
		}
	};

	// <アレルゲン情報>
	const allergyPanel = () => {
		$('.js-allergy-attention').on('click', (e) => {
			let $thisPanel = $(e.currentTarget).next('.js-allergy-attentionPanel');
			if ($thisPanel.hasClass(v)) {
				$thisPanel.removeClass(v);
			} else {
				$('.js-allergy-attentionPanel').removeClass(v);
				$thisPanel.addClass(v);
			}
		});
		$('.js-allergy-attentionPanel').on('click', (e) => {
			$(e.currentTarget).removeClass(v);
		});
		$(document).on('click', (e) => {
			if (!$(e.target).closest('.js-allergy-attention').length) {
				$('.js-allergy-attentionPanel').removeClass(v);
			}
		});
	}

	// <アレルゲン情報描画>
	const createAllergy = () => {
		$('.js-allergy-block').each((idx, ele) => {
			let thisCode = $(ele).find('.rt_cf_pc_series_code_hidden').text();
			getJSONseriesAllergyData(thisCode).then((data) => {
				let productsData = data.rt_bn_products;
				if (productsData.length) {
					for (let i = 0; i < productsData.length; i++) {
						let itemHtml;
						let _supplementHtml = '';
						let _name = productsData[i].cf_p_name;
						let _detailFlg = productsData[i].cf_p_detail_page_flag;
						let _categoryData = productsData[i].cf_p_category;
						let _category = _categoryData.cf_pc_code;
						let _series = _categoryData.cf_pc_series_code;
						let _prodKey = productsData[i]._key;
						// 特定原材料8品目
						let _shrimp = productsData[i].cf_p_specific_allergy_shrimp;
						let _crab = productsData[i].cf_p_specific_allergy_crab;
						let _walnut = productsData[i].cf_p_specific_allergy_walnut;
						let _wheat = productsData[i].cf_p_specific_allergy_wheat;
						let _soba = productsData[i].cf_p_specific_allergy_soba;
						let _egg = productsData[i].cf_p_specific_allergy_egg;
						let _milk = productsData[i].cf_p_specific_allergy_milk;
						let _peanuts = productsData[i].cf_p_specific_allergy_peanuts;
						// 特定原材料に準ずるもの20品目
						let _almond = productsData[i].cf_p_allergy_almond;
						let _abalone = productsData[i].cf_p_allergy_abalone;
						let _squid = productsData[i].cf_p_allergy_squid;
						let _ikura = productsData[i].cf_p_allergy_ikura;
						let _orange = productsData[i].cf_p_allergy_orange;
						let _cashewnuts = productsData[i].cf_p_allergy_cashewnuts;
						let _kiwifruit = productsData[i].cf_p_allergy_kiwifruit;
						let _beef = productsData[i].cf_p_allergy_beef;
						let _sesame = productsData[i].cf_p_allergy_sesame;
						let _salmon = productsData[i].cf_p_allergy_salmon;
						let _mackerel = productsData[i].cf_p_allergy_mackerel;
						let _soy = productsData[i].cf_p_allergy_soy;
						let _chicken = productsData[i].cf_p_allergy_chicken;
						let _banana = productsData[i].cf_p_allergy_banana;
						let _pork = productsData[i].cf_p_allergy_pork;
						let _macadamia = productsData[i].cf_p_allergy_macadamia;
						let _peach = productsData[i].cf_p_allergy_peach;
						let _yamaimo = productsData[i].cf_p_allergy_yamaimo;
						let _apple = productsData[i].cf_p_allergy_apple;
						let _gelatin = productsData[i].cf_p_allergy_gelatin;
						// 備考
						let _remarks = productsData[i].cf_p_allergy_detail_remarks;

						if (_detailFlg === 0) {
							itemHtml += `<tr><td class="__product">
								<a href="/products/${_category}/${_series}/${_prodKey}.html" class="mod-link03"><span class="__txt">${_name}</span></a>
							</td>`;
						} else {
							itemHtml += `<tr><td class="__product">${_name}</td>`;
						}
						// えび
						if (_shrimp === '1') {
							itemHtml += '<td class="_shrimp"><span class="__circle">〇</span></td>';
						} else {
							itemHtml += '<td class="_shrimp"></td>';
						}
						// かに
						if (_crab === '1') {
							itemHtml += '<td class="_crab"><span class="__circle">〇</span></td>';
						} else {
							itemHtml += '<td class="_crab"></td>';
						}
						// くるみ
						if (_walnut === '1') {
							itemHtml += '<td class="_walnut"><span class="__circle">〇</span></td>';
						} else {
							itemHtml += '<td class="_walnut"></td>';
						}
						// 小麦
						if (_wheat === '1') {
							itemHtml += '<td class="_wheat"><span class="__circle">〇</span></td>';
						} else {
							itemHtml += '<td class="_wheat"></td>';
						}
						// そば
						if (_soba === '1') {
							itemHtml += '<td class="_soba"><span class="__circle">〇</span></td>';
						} else {
							itemHtml += '<td class="_soba"></td>';
						}
						// 卵
						if (_egg === '1') {
							itemHtml += '<td class="_egg"><span class="__circle">〇</span></td>';
						} else {
							itemHtml += '<td class="_egg"></td>';
						}
						// 乳
						if (_milk === '1') {
							itemHtml += '<td class="_milk"><span class="__circle">〇</span></td>';
						} else {
							itemHtml += '<td class="_milk"></td>';
						}
						// 落花生
						if (_peanuts === '1') {
							itemHtml += '<td class="_peanuts"><span class="__circle">〇</span></td>';
						} else {
							itemHtml += '<td class="_peanuts"></td>';
						}
						// アーモンド
						if (_almond === '1') {
							itemHtml += '<td class="_almond"><span class="__circle">〇</span></td>';
						} else {
							itemHtml += '<td class="_almond"></td>';
						}
						// あわび
						if (_abalone === '1') {
							itemHtml += '<td class="_abalone"><span class="__circle">〇</span></td>';
						} else {
							itemHtml += '<td class="_abalone"></td>';
						}
						// いか
						if (_squid === '1') {
							itemHtml += '<td class="_squid"><span class="__circle">〇</span></td>';
						} else {
							itemHtml += '<td class="_squid"></td>';
						}
						// いくら
						if (_ikura === '1') {
							itemHtml += '<td class="_ikura"><span class="__circle">〇</span></td>';
						} else {
							itemHtml += '<td class="_ikura"></td>';
						}
						// オレンジ
						if (_orange === '1') {
							itemHtml += '<td class="_orange"><span class="__circle">〇</span></td>';
						} else {
							itemHtml += '<td class="_orange"></td>';
						}
						// カシューナッツ
						if (_cashewnuts === '1') {
							itemHtml += '<td class="_cashewnuts"><span class="__circle">〇</span></td>';
						} else {
							itemHtml += '<td class="_cashewnuts"></td>';
						}
						// キウイフルーツ
						if (_kiwifruit === '1') {
							itemHtml += '<td class="_kiwifruit"><span class="__circle">〇</span></td>';
						} else {
							itemHtml += '<td class="_kiwifruit"></td>';
						}
						// 牛肉
						if (_beef === '1') {
							itemHtml += '<td class="_beef"><span class="__circle">〇</span></td>';
						} else {
							itemHtml += '<td class="_beef"></td>';
						}
						// ごま
						if (_sesame === '1') {
							itemHtml += '<td class="_sesame"><span class="__circle">〇</span></td>';
						} else {
							itemHtml += '<td class="_sesame"></td>';
						}
						// さけ
						if (_salmon === '1') {
							itemHtml += '<td class="_salmon"><span class="__circle">〇</span></td>';
						} else {
							itemHtml += '<td class="_salmon"></td>';
						}
						// さば
						if (_mackerel === '1') {
							itemHtml += '<td class="_mackerel"><span class="__circle">〇</span></td>';
						} else {
							itemHtml += '<td class="_mackerel"></td>';
						}
						// 大豆
						if (_soy === '1') {
							itemHtml += '<td class="_soy"><span class="__circle">〇</span></td>';
						} else {
							itemHtml += '<td class="_soy"></td>';
						}
						// 鶏肉
						if (_chicken === '1') {
							itemHtml += '<td class="_chicken"><span class="__circle">〇</span></td>';
						} else {
							itemHtml += '<td class="_chicken"></td>';
						}
						// バナナ
						if (_banana === '1') {
							itemHtml += '<td class="_banana"><span class="__circle">〇</span></td>';
						} else {
							itemHtml += '<td class="_banana"></td>';
						}
						// 豚肉
						if (_pork === '1') {
							itemHtml += '<td class="_pork"><span class="__circle">〇</span></td>';
						} else {
							itemHtml += '<td class="_pork"></td>';
						}
						// マカダミアナッツ
						if (_macadamia === '1') {
							itemHtml += '<td class="_macadamia"><span class="__circle">〇</span></td>';
						} else {
							itemHtml += '<td class="_macadamia"></td>';
						}
						// もも
						if (_peach === '1') {
							itemHtml += '<td class="_peach"><span class="__circle">〇</span></td>';
						} else {
							itemHtml += '<td class="_peach"></td>';
						}
						// やまいも
						if (_yamaimo === '1') {
							itemHtml += '<td class="_yamaimo"><span class="__circle">〇</span></td>';
						} else {
							itemHtml += '<td class="_yamaimo"></td>';
						}
						// りんご
						if (_apple === '1') {
							itemHtml += '<td class="_apple"><span class="__circle">〇</span></td>';
						} else {
							itemHtml += '<td class="_apple"></td>';
						}
						// ゼラチン
						if (_gelatin === '1') {
							itemHtml += '<td class="_gelatin"><span class="__circle">〇</span></td>';
						} else {
							itemHtml += '<td class="_gelatin"></td>';
						}
						// 備考
						if (_remarks === '') {
							itemHtml += '<td class="__attention"></td>';
						} else {
							itemHtml += `<td class="__attention">
								<span class="mod-link04 js-allergy-attention">※</span>
								<div class="__attentionPabel js-allergy-attentionPanel">
									<p class="__head">【注 意】</p>
									<p class="">${_remarks.replace(/\n/g, '<br>')}</p>
								</div>
							</td>`;
						}

						itemHtml += '</tr>';
						$(ele).find('.js-allergy-tbl').append(itemHtml);

						// if (idx + 1 === $('.js-allergy-block').length) {
						// 	if (i + 1 === productsData.length) {
						// 		allergyPanel();
						// 	}
						// }
					}
				}
			}).then(() => {
				if (idx + 1 === $('.js-allergy-block').length) {
					allergyPanel();
				}
			});
		});
	};

	// <販売終了商品>
	const endOfSalesList = () => {
		$('.js-endOfSalesList-wrap').each((idx, ele) => {
			let thisId = $(ele).find('.rt_key_hidden').text();
			let productsArr = [];
			getJSONoldCategoryData(thisId).then((data) => {
				let productsData = data.rt_bn_products;
				if (productsData.length) {
					for (let i = 0; i < productsData.length; i++) {
						let _endYear = productsData[i].cf_p_end_sale_day;
						let _endSeason = productsData[i].cf_p_end_sale_season;
						let sortNum = '';

						if (_endSeason === '冬') {
							sortNum = 0;
						} else if (_endSeason === '秋') {
							sortNum = 1;
						} else if (_endSeason === '夏') {
							sortNum = 2;
						} else if (_endSeason === '春') {
							sortNum = 3;
						} else {
							sortNum = 4;
						}

						let productsArrItem = {
							sort: sortNum,
							year: _endYear,
							data: productsData[i]
						};
						productsArr.push(productsArrItem);
					}
				} else {
					$(ele).remove();
					$('.mod-anchor01-item-a[href="#' + thisId + '"]').parent('.mod-anchor01-item').remove();
				}
			}).then(() => {
				productsArr.sort(
					function (x, y) {
						let xDate = x['sort'];
						let yDate = y['sort'];
						if (xDate > yDate) return (1);
						if (xDate < yDate) return (-1);
						return 0;
					}
				);
				productsArr.sort(
					function (x, y) {
						let xDate = x['year'];
						let yDate = y['year'];
						if (xDate < yDate) return (1);
						if (xDate > yDate) return (-1);
						return 0;
					}
				);

				for (let i = 0; i < productsArr.length; i++) {
					let _name = productsArr[i].data.cf_p_name_end;
					let _img = productsArr[i].data.cf_p_img_end;
					let _alt = productsArr[i].data.cf_p_img_alt_end;
					let _title = productsArr[i].data.cf_p_img_title_end;
					let _endYear = productsArr[i].data.cf_p_end_sale_day;
					let _endSeason = productsArr[i].data.cf_p_end_sale_season;
					let _capacity = productsArr[i].data.cf_p_capacity_end;
					let _comment = productsArr[i].data.cf_p_replacement_comment;
					let _replacementFlg = productsArr[i].data.cf_p_detail_page_flag;
					let _replacementProducts = productsArr[i].data.cf_p_replacement_products;
					let _categoryData = productsArr[i].data.cf_p_category;
					let _category = _categoryData.cf_pc_code;
					let _series = _categoryData.cf_pc_series_code;
					let _prodKey = productsArr[i].data._key;
					let _limit = productsArr[i].data.cf_p_limit_flag_end;
					let limitHtml = '';
					let linkClass = 'is-disable';
					let thisHref = '';
					let sortNum = '';

					let commentTxt = 'なし';

					if (_img === '') {
						_img = 'dummy440×293.jpg';
					}


					// 限定表示
					if (_limit === 1) {
						limitHtml = '<span class="__label">季節限定</span>';
					} else if (_limit === 2) {
						limitHtml = '<span class="__label">期間限定</span>';
					} else if (_limit === 3) {
						limitHtml = '<span class="__label">地域限定</span>';
					}

					//if(_displayFlg === 1 && _replacementFlg === 0) {
					// thisHref = '/products/'+ _category +'/'+ _series +'/' + _prodKey +'.html';
					// commentTxt = `<a href="${thisHref}" class="__link">あり（${_comment}）</a>`;
					// linkClass = '';
					//} else if(_displayFlg === 1 && _replacementFlg === 1) {
					//commentTxt = `<span>あり（${_comment}）</span>`;
					// }

					// 代替商品（リニューアル以外）ありの場合
					if (_replacementProducts !== undefined && _replacementProducts !== null) {
						getJSONproductsData(_replacementProducts._key).then((data2) => {
							if (data2.rt_bn_products_list.length) {
								let _replaceCategory = data2.rt_bn_products_list[0].cf_p_category;
								commentTxt = 'あり';
								thisHref = '/products/' + _replaceCategory.cf_pc_code + '/' + _replaceCategory.cf_pc_series_code + '/' + _replacementProducts._key + '.html';
								if (_comment !== '') {
									commentTxt += '（' + _comment + '）';
								}
								commentTxt = `<a href="${thisHref}" class="__link">${commentTxt}</a>`;
								linkClass = '';
							} else {
								commentTxt = 'なし';
								linkClass = 'is-disable';
								thisHref = '';
							}
						}).then(() => {
							let thisHtml = `<li class="pure-u-1-4 pure-u-lg-1-2 mod-boxLink-spacer01-child" style="order: ${i};">
								<a href="${thisHref}" class="products-item ${linkClass}">
									<div class="products-item-img">
										<figure class="__img">
											<img src="/products/products_file/file/${_img}" alt="${_alt}" title="${_title}" class="width-u-100" loading="lazy">
										</figure>
										<p class="__end_of_sales">${_endYear}${_endSeason} 販売終了</p>
									</div>
									<div class="products-item-txt">
										${limitHtml}
										<p class="__name">${_name}</p>
									</div>
								</a>
								<div class="products-item-txt mt0">
									<p class="__capacity">内容量：<span class="">${_capacity}</span></p>
									<p class="__substitute">代わりの商品：${commentTxt}</p>
								</div>
							</li>`;
							$(ele).find('.js-endOfSalesList').append(thisHtml);
						});
					} else {
						// 代替商品（リニューアル以外）ないの場合

						let thisHtml = `<li class="pure-u-1-4 pure-u-lg-1-2 mod-boxLink-spacer01-child" style="order: ${i};">
							<a href="${thisHref}" class="products-item ${linkClass}">
								<div class="products-item-img">
									<figure class="__img">
										<img src="/products/products_file/file/${_img}" alt="${_alt}" title="${_title}" class="width-u-100" loading="lazy">
									</figure>
									<p class="__end_of_sales">${_endYear}${_endSeason} 販売終了</p>
								</div>
								<div class="products-item-txt">
									${limitHtml}
									<p class="__name">${_name}</p>
								</div>
							</a>
							<div class="products-item-txt mt0">
								<p class="__capacity">内容量：<span class="">${_capacity}</span></p>
								<p class="__substitute">代わりの商品：${commentTxt}</p>
							</div>
						</li>`;

						$(ele).find('.js-endOfSalesList').append(thisHtml);
					}
				}
			});
		});
	}


	// ==============================================================================
	// <商品情報TOP>
	topMainSlider();
	newProducts();
	campaignSlider();
	deliciousnessSlider();
	recommendContentsSlider();
	brandSlider();

	// <商品検索>
	if ($('.js-search-input').length) {
		productsSearch();
	}
	// <商品検索結果>
	if ($('.js-brandstorySlider').length) {
		brandStorySlider();
	}
	// <カテゴリ>
	// categoryRecipeSlider();
	creteSeriesRecipe();
	categoryTab();
	// <アレルゲン情報>
	if ($path === '/products/allergy.html') {
		// allergyPanel();
		createAllergy();
	}
	// <商品詳細>
	detailRecipe();
	tableSwipe();
	detailAllergy();
	detailAllergyToggle();
	if ($('.js-products-info').length) {
		detailItemDisplay();
	}
	// <販売終了商品>
	if ($('.js-endOfSalesList').length) {
		endOfSalesList();
	}


})(window.jQuery, window.RIKEN);
